// begin checkmq 
// Fn Toggling "rwd-desktop" or "rwd-mobile"
var fn_mq = function () {

    function checkMq() {
        if (Modernizr.mq('all and (max-width: 1199px)')) {
        // Adding class for non desktop RWD
            $('html').removeClass('rwd-desktop').addClass('rwd-mobile')
        } else {
        // Adding class for desktop RWD
            $('html').removeClass('rwd-mobile').addClass('rwd-desktop')
        }

        if (Modernizr.mq('all and (max-width: 991px)')) {
            // Adding class for non desktop RWD
                $('html').removeClass('slider-md-off').addClass('slider-md-on')
            } else {
            // Adding class for desktop RWD
                $('html').removeClass('slider-md-on').addClass('slider-md-off')
        }
    }

    checkMq();

    $(window).on('load, resize', function () {
        checkMq();
    });

};
